/*
 Copyright (c) 2015, salesforce.com, inc. All rights reserved.

 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

import PropTypes from 'prop-types';
import React from 'react';

import { PopoverTooltip } from '@salesforce/design-system-react';

const blankGuid = '00000000-0000-0000-0000-000000000000';

const minDragTime = 150; // 150ms or 0.15s
let dragStart = 0;

function JourneyTemplateCard(props) {
  return (
    <div
      className="journey-templates-card"
      onClick={() => {
        const dateNow = Date.now();

        // This is a work around for the drag functioniality used in slick-carousel.
        // Clicking on a card should deep link user to the journey template, however when a user
        // clicks and drags a card they should not be directed away from the homepage.
        // Unfortunatly timing must be used because the slick-react library does not currently support
        // the dragStart method if the user stops the carousel in the same position they started in.
        if (dateNow - dragStart < minDragTime) {
          props.onDeepLink({
            appName: 'Journey Builder',
            analyticsName: props.template.name,
            link: `/#${blankGuid}/1?templateId=${props.template.id}`,
          });
        }
      }}
      role="button"
      tabIndex="0"
      onKeyPress={() => {}}
      onMouseDown={() => {
        dragStart = Date.now();
      }}
      data-template-id={props.template.id}
    >
      <div className="journey-templates-card-header" data-lifecycle-color={props.template.lifecycleData}>
        <div className="journey-templates-card-header-left">
          <div
            className="journey-templates-card-header-lifecycle-icon"
            data-lifecycle-icon={props.template.lifecycleData}
          />
          <div className="journey-templates-card-header-lifecycle">{props.template.lifecycle}</div>
        </div>
      </div>
      <div className="journey-templates-card-ribbon" data-complexity={props.template.complexityData}>
        {props.template.complexity}
      </div>
      <div className="journey-templates-card-content">
        <div className="journey-templates-card-content-name">{props.template.name}</div>
        <div className="journey-templates-card-content-description">{props.template.description}</div>
      </div>
      <div className="journey-templates-card-footer">
        {props.template.tagContent && (
          <div className="slds-float_right">
            <PopoverTooltip align="bottom" content={props.template.tagContent} position="overflowBoundaryElement">
              <div
                className="tile-tag tile-tag--view-more"
                role="button"
                tabIndex="0"
                aria-label={`${props.template.name}: ${props.template.tagContent}`}
              >
                ...
              </div>
            </PopoverTooltip>
          </div>
        )}
        {props.template.tagOne && (
          <span className="tile-tag slds-float_right" title={props.template.tagOne}>
            {props.template.tagOne}
          </span>
        )}
        {props.template.tagTwo && (
          <span className="tile-tag slds-float_right" title={props.template.tagTwo}>
            {props.template.tagTwo}
          </span>
        )}
      </div>
    </div>
  );
}

JourneyTemplateCard.displayName = 'Journey Template Card';

JourneyTemplateCard.propTypes = {
  template: PropTypes.object,
  onDeepLink: PropTypes.func,
  checkDragState: PropTypes.func,
};

export default JourneyTemplateCard;
